export default __webpack_public_path__ + "static/media/hero_bg.c9bee329.png";